import { Component, OnInit } from '@angular/core';
import { PeerToPeerSuccessComponent } from '../peer-to-peer-success/peer-to-peer-success.component';
import { SharedPeerToPeerConfirmationModule } from '@pages/send-money/components/peer-to-peer-confirmation/shared-peer-to-peer-confirmation.module';
import { SharedPeerToPeerConfirmationComponent } from '@pages/send-money/components/peer-to-peer-confirmation/shared-peer-to-peer-confirmation.component';

@Component({
    standalone: true,
    selector: 'app-peer-to-peer-confirmation',
    templateUrl: './peer-to-peer-confirmation.component.html',
    styleUrls: ['./peer-to-peer-confirmation.component.scss'],
    imports: [SharedPeerToPeerConfirmationModule],
})
export class PeerToPeerConfirmationComponent extends SharedPeerToPeerConfirmationComponent implements OnInit {
    ngOnInit() {
        this.redirectToComponent = PeerToPeerSuccessComponent;
    }
}
